// extracted by mini-css-extract-plugin
export default {"container":"followBtn_container__HvO5C","button":"followBtn_button__dk-ss","followIcon":"followBtn_followIcon__KR1VZ","lockIcon":"followBtn_lockIcon__5jdZV"};